<template>
  <div class="home-screen">
    <div class="video-view">
      <div class="swiper-container">
        <div class="swiper-wrapper" v-if="homeMusic.length > 0">
          <div class="swiper-slide" v-for="(item, i) in homeMusic" :key="i">
            <div class="post-header" v-if="item">
              <span class="new-icon">
                <img :src="item.app_icon_url" alt="user_profile" />
              </span>
            </div>
            <Player
              v-if="currentSlideHome == i"
              class="vdo-screen"
              :video_link="item.video_url"
              :id="`player${i}`"
            />

            <div class="news-titleblk ">
              <h2>
                {{ item.title }}
              </h2>
              <div class="dtl-btn-blk">
                <div class="share-btn" @click="share(item)">
                  <share-icon />Share
                </div>

                <button class="news-detail-btn" @click="handleOpen(item, i)">
                  Read More
                </button>
              </div>
              <div class="provider-name">
                <span>News Provider -</span> {{ item.provider_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader91 v-if="isLoading" />
  </div>
</template>

<script>
import Player from './Player';
import HomeIcon from './svgIcons/HomeIcon';
import ProfileIcon from './svgIcons/ProfileIcon';
import PlusIcon from './svgIcons/PlusIcon';
import HeartIcon from './svgIcons/HeartIcon';
import CommentIcon from './svgIcons/CommentIcon';
import ShareIcon from './svgIcons/ShareIcon';
import ArrowTickIcon from './svgIcons/ArrowTickIcon';
import PostWallIcon from './svgIcons/PostWallIcon';
import { BASE_API } from '../utils/constants';

export default {
  name: 'home',

  components: {
    Player,
    HomeIcon,
    ProfileIcon,
    PlusIcon,
    HeartIcon,
    CommentIcon,
    ShareIcon,
    ArrowTickIcon,
    PostWallIcon,
  },

  data() {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      isLoading: false,
      xauthid: this.$cookies.get('X-Auth-Id'),
      xauthtoken: this.$cookies.get('X-Auth-Token'),
      liked: false,
      followed: false,
      showCommentModal: false,
      currentVideoId: 1,
      commentKey: 1,
      comments: [],
      // swiper: null,
      isLoadingLike: false,
    };
  },

  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(newValue) {
        return this.$store.dispatch('setUser', newValue);
      },
    },
    selecteduser: {
      get() {
        return this.$store.state.selecteduser;
      },
      set(newValue) {
        return this.$store.dispatch('setSelectedUser', newValue);
      },
    },
    processing: {
      get() {
        return this.$store.state.processing;
      },
      set(newValue) {
        return this.$store.dispatch('setProcessing', newValue);
      },
    },
    homeMusic: {
      get() {
        return this.$store.state.homeMusic;
      },
      set(newValue) {
        return this.$store.dispatch('setHomeMusic', newValue);
      },
    },
    currentSlideHome: {
      get() {
        return this.$store.state.currentSlideHome;
      },
      set(newValue) {
        return this.$store.dispatch('setCurrentSlideHome', newValue);
      },
    },
    pageHome: {
      get() {
        return this.$store.state.pageHome;
      },
      set(newValue) {
        return this.$store.dispatch('setPageHome', newValue);
      },
    },
    isStartAutoplay: {
      get() {
        return this.$store.state.isStartAutoplay;
      },
      set(newValue) {
        return this.$store.dispatch('setIsStartAutoplay', newValue);
      },
    },
    swiper: {
      get() {
        return this.$store.state.swiper;
      },
      set(newValue) {
        return this.$store.dispatch('setswiper', newValue);
      },
    },
  },

  async mounted() {
    this.getVideo();
    if (Object.keys(this.homeMusic).length > 0) {
      setTimeout(
        (t) => {
          t.swiper.destroy();
          t.callSwiper();
          t.swiper.autoplay.stop();
          t.isLoading = false;
        },
        100,
        this
      );
    }
    //else {
    // this.createUser();
    // }
  },

  watch: {
    isStartAutoplay() {
      if (this.isStartAutoplay) {
        this.swiper.autoplay.start();
      } else {
        this.swiper.autoplay.stop();
      }
    },
  },

  methods: {
    handleOpen(item, i) {
      this.currentSlideHome = i;
      window.open(item.link);
      // this.$router.push({ name: 'NewsInDetail', query: item.link })
    },
    // async createUser() {
    //   this.isLoading = true;
    //   if (this.xauthid !== null) {
    //     if (Object.keys(this.user).length == 0) {
    //       let userDetails = await this.axios.post(
    //         `https://test.services-money91.com/api/createuser`,
    //         {
    //           xauthid: this.xauthid,
    //         }
    //       );

    //       if (userDetails !== null && userDetails.data.status) {
    //         this.user = userDetails.data.user;
    //         await this.getVideo();
    //         this.isLoading = false;
    //       } else {
    //         // this.$toast.bottom(userDetails.data.message);
    //         this.$toast.bottom('Network error!');
    //       }
    //     } else {
    //       this.isLoading = false;
    //     }
    //   }
    // },
    async share(item, i) {
      try {
        JSBridgePlugin.downloadVideoAndShare(
          item.video_url,
          item.title + ' via #news91 #mall91'
        );
      } catch (e) {
        console.log(e);
      }
    },
    async getPaginatedVideo() {
      this.isLoading = true;
      let vdo = await this.axios.get(
        `https://test.services-money91.com/news91/news91/v2/get_news/v3/${this.pageHome}/`,
        {
          xauthid: this.xauthid,
        }
      );
      if (vdo !== null && vdo.data) {
        this.homeMusic = [...this.homeMusic, ...vdo.data];
        this.isLoading = false;
      } else {
        this.$toast.bottom(vdo.data.message);
        this.isLoading = false;
      }
    },

    async getVideo() {
      if (this.swiper !== null) {
        this.swiper.destroy();
      }
      this.isLoading = true;
      let vdo = await this.axios.get(
        `${BASE_API}/news91/news91/v2/get_news/v3/0/`,
        {
          xauthid: this.xauthid,
          page: this.pageHome,
        }
      );
      if (vdo !== null && vdo.data) {
        this.homeMusic = vdo.data;
        setTimeout(
          (t) => {
            t.callSwiper();
            t.swiper.autoplay.stop();
            console.log('enter');
            t.isLoading = false;
          },
          100,
          this
        );
      } else {
        this.$toast.bottom(vdo.data.message);
        this.isLoading = false;
      }
    },

    // videoDuration(e) {
    //   console.log("sds");
    //   console.log(e);
    //   this.videoLength = e;
    // },

    callSwiper() {
      let t = this;
      t.swiper = new Swiper('.swiper-container', {
        direction: 'vertical',
        allowSlideNext: true,
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
        observer: true,
        initialSlide: t.currentSlideHome,
        autoplay: {
          delay: 0,
        },
      });
      // t.pageHome == 0
      // t.currentSlideHome = 0;
      t.currentVideoId = t.homeMusic[t.currentSlideHome].id;
      // t.checkLiked(t.currentSlideHome);
      // t.checkfollowed(t.currentSlideHome);
      // t.getComments();
      t.swiper.on('slideChange', function() {
        console.log(t.swiper.realIndex);
        t.isLoadingLike = false;
        t.currentSlideHome = t.swiper.realIndex;
        t.currentVideoId = t.homeMusic[t.currentSlideHome].id;
        // t.checkLiked(t.swiper.realIndex);
        // t.checkfollowed(t.swiper.realIndex);
        // t.getComments();
        if (t.pageHome == 0) {
          if (t.swiper.realIndex == 9 && t.homeMusic.length == 10) {
            t.pageHome = 1;
            t.getPaginatedVideo();
          }
        } else {
          if (
            t.swiper.realIndex == t.homeMusic.length - 1 && //19
            t.homeMusic.length == (t.pageHome + 1) * 10 //20
          ) {
            t.pageHome += 1;
            t.getPaginatedVideo();
          }
          // if (
          //   t.swiper.realIndex == t.homeMusic.length - 1 && //19
          //   t.homeMusic.length == (t.pageHome+1)*10 //20
          // ) {
          //   t.pageHome += 1;
          //   t.getPaginatedVideo();
          // }
        }
      });
    },

    tagvalue(tags) {
      return tags.trim().split('#');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/home-screen.scss';
</style>
